import React from "react";
import { Alert, Link } from "@mui/material";
import { getProjectCustomerEmailIssue } from "./createProjectValidation";

// Used by both New Project entry points: the email value comes from the
// selected customer record and is not editable in the project modal.
export default function ProjectCustomerEmailNotice({ email, customerId, instanceUniqueId }) {
  const issue = getProjectCustomerEmailIssue(email);
  if (!customerId || !issue) return null;

  const customerUrl = `/instance/${encodeURIComponent(instanceUniqueId)}/sales/customers?tab=all&openCustomer=${encodeURIComponent(customerId)}`;

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      <strong>
        {issue === "missing" ? "Customer email address is missing." : "Customer email address is invalid."}
      </strong>{" "}
      A valid email on the customer account is required to create this project.{" "}
      <Link href={customerUrl} target="_blank" rel="noopener noreferrer" underline="hover">
        Open customer profile
      </Link>
      {" "}to update it, then reopen New Project and select the customer again.
    </Alert>
  );
}
